// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__3TdB_","disabled":"FileBtn_disabled__1Igp9","warn":"FileBtn_warn__yCe7w","fade":"FileBtn_fade__bmkag"};